import React, { useState, Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import Input from "../../../inputs/inputs";
import Button from "../../../buttons/buttons";
import CLOSE from "../../../../assets/images/icons/close.svg";
import AddPackageSkeleton from "../../../skeleton/addPackage";
import ErrorImg from "../../../../assets/images/emptyState/restaurant-list.jpg";
import SearchableDropdown from "../../../../helpers/searchableDropDown";
import { searchFoodAction } from "../../../../redux/food/foodActions";
import { getAllRestaurantsAction } from "../../../../redux/restaurant/restaurantActions";

export function AttachFood(props) {
  const {
    selectedFood,
    setSelectedFood,
    selectedFoodArr,
    showFood,
    setShowFood,
    setSelectedFoodArr,
  } = props;
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [show_search, setShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [outlet, setOutlet] = useState("");
  const { search, searching } = useSelector((state) => state.food);
  const { allRestaurants } = useSelector((state) => state.restaurant);
  const restaurantData = allRestaurants?.data;

  useEffect(() => {
    dispatch(getAllRestaurantsAction());
    // eslint-disable-next-line
  }, []);

  function closeModal() {
    setIsOpen(false);
  }

  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchValue(value);
    e.preventDefault();
    if (value.length > 2) {
      setShowSearch(true);
      dispatch(
        searchFoodAction({
          search: value,
          restaurant_id: outlet,
        })
      );
    }
  };

  function handleSelected(item) {
    setShowSearch(false);
    setSelectedFood([...selectedFood, item]);
    setSelectedFoodArr([...selectedFoodArr, item.id]);
  }
  const removeItem = (i) => {
    const filtered = selectedFood.filter((item, index) => index !== i);
    setSelectedFood(filtered);
  };
  function handleContinue() {
    setShowFood([...showFood, selectedFood]);
    closeModal();
  }

  const onImageError = (e) => {
    e.target.src = ErrorImg;
  };

  const selectRestaurantOption = (option) => {
    const value = option?.id;
    setOutlet(value);
  };

  return (
    <>
      {showFood.length === 0 && (
        <button
          type="button"
          className="border border-dashed border-[#C2C9D1] text-center p-3 w-full"
          onClick={() => setIsOpen(true)}
        >
          --Attach--
        </button>
      )}
      {showFood.length > 0 && (
        <p
          className="text-sm text-primary mb-2 cursor-pointer "
          onClick={() => setIsOpen(true)}
        >
          Add more+
        </p>
      )}
      <Transition appear show={isOpen}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-full min-h-[502px] sm:w-[650px] sm:max-w-2xl bg-white px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:p-8">
                  <div>
                    <div className=" sm:block absolute top-3 right-2 pt-4 pr-4">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-sm p-1 sm:p-3  "
                        onClick={closeModal}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className=" w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>
                    <div className="pb-3 text-center sm:text-center border-b border-[#E4E4F3]">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-bold text-black "
                      >
                        Attach Food
                      </Dialog.Title>
                    </div>
                  </div>

                  <div className="mt-8">
                    <div className="mt-4">
                      <label
                        htmlFor="store_id"
                        className="text-sm font-medium text-[#151515]"
                      >
                        Restaurant
                      </label>
                      <SearchableDropdown
                        options={restaurantData}
                        label="restaurant_name"
                        name={"restaurant_id"}
                        placeholder={"Select a restaurant"}
                        selectOption={selectRestaurantOption}
                      />
                    </div>

                    <div className="relative">
                      <Input.Label
                        title={"Food"}
                        type="search"
                        id="search"
                        value={searchValue}
                        className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                        placeholder="Search foods."
                        onChange={handleSearch}
                      />
                      {searching ? (
                        <div className="absolute w-full bg-white shadow top-[68px]">
                          <div className="p-3">
                            <AddPackageSkeleton />
                          </div>
                        </div>
                      ) : (
                        show_search &&
                        search?.length > 0 && (
                          <div className="absolute w-full bg-white shadow top-[68px]">
                            <div className="p-3">
                              {search?.length > 0 &&
                                search?.map((item, i) => (
                                  <div
                                    key={i}
                                    className="flex justify-between cursor-pointer mb-2 hover:border-b"
                                    onClick={() => handleSelected(item)}
                                  >
                                    <div>
                                      {" "}
                                      <p className="text-sm">
                                        {item?.food_name}
                                      </p>{" "}
                                    </div>
                                    <p className="text-primary text-sm">
                                      + Add
                                    </p>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    {selectedFood?.length > 0 && (
                      <div>
                        {selectedFood?.map((food, i) => (
                          <div
                            key={i}
                            className="flex items-center gap-6  mb-4"
                          >
                            <div>
                              <img
                                src={food?.food_pictures ?? ErrorImg}
                                onError={onImageError}
                                className="h-[52px] w-[130px] object-cover rounded-md"
                                alt="food"
                              />
                            </div>
                            <div className="w-full">
                              <h4 className="text-md mb-1">
                                {food?.food_name}
                              </h4>
                              <p className="text-xs">{food?.id}</p>
                            </div>
                            <div className="w-full text-right">
                              <button
                                className="text-primary text-md"
                                onClick={() => removeItem(i)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <div>
                      <Button.Primary
                        className="rounded-sm flex justify-center mx-auto mt-5"
                        title={"Continue"}
                        onClick={handleContinue}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
